import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import ToDateNotificator from 'components/ToDateNotificator';
import { formatOrder } from 'components/CodeInfo';
import CodeInfoSection from 'components/CodeInfoSection';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoImportVat extends Component {

    render() {
        const { vat } = this.props;
        const summary = getTitleSummary(vat)
        return (
            <CodeInfoSection
                title={{
                    headers: ['НДС'],
                    rows: summary
                }}
                expanded={(vat.length !== 0) ? true : false}
                table={{
                    headers: [
                        '',
                        'Страна',
                        'Описание',
                        'Ставка',
                        'Нормативный документ'
                    ],
                    rows: vat.map(({ to_date = null, country = '', description = '', rate = '', order, order_date, orders_info = null }) => ([
                        <ToDateNotificator to_date={to_date} />,
                        country,
                        description,
                        rate,
                        formatOrder(order, order_date, orders_info)
                    ]))
                }}
            />
        );
    }
}

function getTitleSummary(items) {
    var rate = items.length !== 0 ? `${items[0].rate}%` + (items.length > 1 ? ' (базовая ставка)' : '') : 'нет';
    items.forEach(element => {
        if (element.description === 'Базовая ставка') {
            rate = `${element.rate}%` + (items.length > 1 ? ' (базовая ставка)' : '');
            return;
        }
    });
    return [[rate]];
}






// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoImportVat.js